import { atom } from 'recoil';

type TState = {
  data: {
    sggCd?: string;
    emdCd?: string;
    treeKindCd?: string;
    searchAddr?: string;
    detId?: string;
  };
};

const loadLayerState = atom<TState>({
  key: 'loadLayerState',
  default: {
    data: {},
  },
});

export default loadLayerState;
